import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: resolve => require(['@/page/home'], resolve),
    },
    {
      path: '/product',
      name: 'product',
      component: resolve => require(['@/page/product'], resolve),
    },
    {
      path: '/partner',
      name: 'partner',
      component: resolve => require(['@/page/partner'], resolve),
    },
    {
      path: '/news',
      name: 'news',
      component: resolve => require(['@/page/news/index'], resolve),
    },
    {
      path: '/hotspot',
      name: 'news',
      component: resolve => require(['@/page/news/hotspot'], resolve),
    },
    {
      path: '/news/detail',
      name: '/news/detail',
      component: resolve => require(['@/page/news/detail'], resolve),
    },
    {
      path: '/about',
      name: 'about',
      component: resolve => require(['@/page/about/index'], resolve),
      children:[
        {
          path: '',
          name: 'us',
          component: resolve => require(['@/page/about/us'], resolve),
        },
        {
          path: 'history',
          name: 'history',
          component: resolve => require(['@/page/about/history'], resolve),
        },
        {
          path: 'contact',
          name: 'contact',
          component: resolve => require(['@/page/about/contact'], resolve),
        },
        {
          path: 'join',
          name: 'join',
          component: resolve => require(['@/page/about/join'], resolve),
        },
      ]
    },
    {
      path: '/english',
      name: 'english',
      component: resolve => require(['@/page/english'], resolve),
    },
    {
      path: '/media',
      name: 'media',
      component: resolve => require(['@/page/media'], resolve),
    },
    {
      path: '/price',
      name: 'price',
      component: resolve => require(['@/page/price'], resolve),
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/page/login'], resolve),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js